/* Re-measure on mobile, font changes and theme-editor section replacement. */
if (!customElements.get('network-announcement-bar')) {
  customElements.define('network-announcement-bar', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const height = this.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--network-announcement-height', `${height}px`);
      };
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      const remaining = document.querySelector('network-announcement-bar');
      document.documentElement.style.setProperty('--network-announcement-height',
        `${remaining ? remaining.getBoundingClientRect().height : 0}px`);
    }
  });
}
